import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { LoadedSchema } from '@cli-types/core-engine/schema-reader.js'
import { validateLoadedSchema } from '@core-engine/schema/schema-reader/validate-loaded-schema.js'
import { applyGeneratedFiles } from '@next-adapter/snapshots/apply/apply-generated-files.js'
import { runLoadedPipeline } from './run-loaded-pipeline.js'

export async function applyGeneratedSchema(
  cwd: string,
  config: ResolvedBetterstartConfig,
  loaded: LoadedSchema,
  outputNamespace?: string
): Promise<void> {
  const validationErrors = validateLoadedSchema(loaded)
  if (validationErrors.length > 0) {
    throw new Error(validationErrors.join('; '))
  }

  const pipelineResult = runLoadedPipeline(loaded, cwd, config, outputNamespace)
  if (!pipelineResult.success) {
    throw new Error(pipelineResult.errors.join('; '))
  }

  await applyGeneratedFiles({
    cwd,
    config,
    scope: loaded.schema.name,
    schemaJson: loaded.schema,
    generatedFiles: pipelineResult.files,
    force: false,
    interactive: false
  })
}
